import './simple-text.scss';

export default {
  label: 'label-override',
  group: 'form-group',
  text: 'form-control',
  inputWrapper: '',
  readOnlyText: 'form-control readonly-text',
  requiredIndicator: 'required-indicator',
}
